import React, { useState, useEffect } from "react";
// componentes
import { Modal, ModalBody, ModalHeader, Col, Row, Button } from "reactstrap";
import Select from "react-select";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
import ColorPicker from "../../../components/ColorPicker/ColorPicker";
import ModalGoBackFunction from "./ModalGoBackFunction";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
// redux
import { connect } from "react-redux";
// service
import { newMenu } from "../../../utils/services/menus";
import { getGroups } from "../../../utils/services/group";
import { getUrlFiles } from "../../../utils/services/files";

function NewMenu(props) {
  const { isOpen, toggle } = props;
  const [modalBackdrop, setModalBackdrop] = useState(false);
  // dados do form
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");
  const [nameExhibition, setNameExhibition] = useState("");
  const [icon, setIcon] = useState(null);
  const [isVisible, setIsVisible] = useState(true);
  const [isEmbeded, setIsEmbeded] = useState(false);
  //state de grupos
  const [groups, setGroups] = useState([]);
  const [allGroups, setAllGroups] = useState(false);
  //state de grupos selecionados
  const [groupsMulti, setGroupsMulti] = useState([]);
  //confirmação
  const [successDlg, setSuccessDlg] = useState(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState("");
  //state de erros
  const [nameErro, setNameErro] = useState("");
  const [urlErro, setUrlErro] = useState("");
  const [nameExErro, setNameExErro] = useState("");
  const [imageErro, setImageErro] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // check
  const [separateText, setSeparateText] = useState(false);
  // cor do texto
  const [colorText, setColorText] = useState("#fff");
  // remover topo
  const [hideHeader, setHideHeader] = useState(false);
  // cor do topo
  const [headerColorEnabled, setHeaderColorEnabled] = useState(false);
  const [headerColor, setHeaderColor] = useState("#000000");

  // alterna o backdrop do modal
  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }

  // controla a seleção de grupos, tratando a opção "TODOS" como exclusiva
  function handleGroupMulti(a) {
    const selected = a.filter((e) => e.value === "todos");
    if (selected.length > 0) {
      a = selected;
      setAllGroups(true);
    } else {
      setAllGroups(false);
    }
    setGroupsMulti(a);
  }

  // valida o form, envia o ícone e cria o botão de menu
  async function submitForm(e) {
    e.preventDefault();

    if (name === "") {
      setNameErro("O campo Nome é obrigatório.");
      return;
    } else setNameErro("");

    if (url === "") {
      setUrlErro("O campo URL é obrigatório.");
      return;
    } else setUrlErro("");

    if (nameExhibition === "") {
      setNameExErro("O campo Nome de Exibição é obrigatório.");
      return;
    } else setNameExErro("");

    if (!icon) {
      setImageErro("O campo Ícone é obrigatório.");
      return;
    } else setImageErro("");

    setIsLoading(true);

    //array de grupos
    const groupsArray = [];

    if (allGroups) {
      groups.forEach((e) => {
        groupsArray.push({ grupo: e.id });
      });
    } else {
      groupsMulti.forEach((e) => {
        groupsArray.push({ grupo: e.value });
      });
    }

    let urlImg = "";
    let expireDate = null;
    let expireDateRa = null;

    const data = new FormData();
    data.append("files", icon.files[0]);
    data.append("folder", "menu");
    data.append("eventId", props.idEvent);

    try {
      const response = await getUrlFiles(
        data,
        props.state.global_user_data.data.token,
      );
      response.forEach((file) => {
        urlImg = file.url;
        expireDate = file.expires;
      });
    } catch (error) {
      console.error("Erro ao enviar o ícone:", error);
      setSubmitErrorMessage("Erro ao enviar o ícone.");
      setIsLoading(false);
      return;
    }

    const form = {
      order: props.menus.length + 1,
      columnSize: 1,
      description: name
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s/g, "")
        .toUpperCase(),
      nameExhibition: nameExhibition,
      textSeparator: separateText,
      fontColor: separateText ? colorText : "#000000",
      backgroundColor: "#fff",
      backgroundImage: urlImg,
      typeBtn: "default",
      linkUrl: url,
      isEmbeded: isEmbeded,
      isVisible: isVisible,
      menuId: props.idButton,
      isDefault: false,
      grupos: groupsArray,
      expireDate: expireDate,
      expireDateRa: expireDateRa,
      hideHeader: hideHeader,
      headerColor: headerColorEnabled && !hideHeader ? headerColor : null,
    };

    try {
      const menuData = await newMenu(
        form,
        props.state.global_user_data.data.token,
      );
      if (menuData.message === "created") {
        setSuccessDlg(true);
      }
    } catch (error) {
      console.error("Erro ao criar o botão:", error);
      setSubmitErrorMessage("Erro ao criar o botão.");
    } finally {
      setIsLoading(false);
    }
  }

  // busca os grupos do evento para o select de segmentação
  async function getGroupsFunc() {
    try {
      const response = await getGroups({
        jwt: props.state.global_user_data.data.token,
        eventId: props.idEvent,
        offset: 1,
        limit: 0,
        search: "",
      });
      setGroups(response.findOneGroupData.data);
    } catch (error) {
      console.error("Erro ao buscar grupos:", error);
      toast.error("Erro ao buscar grupos.");
    }
  }

  useEffect(() => {
    getGroupsFunc();
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggleBackdrop();
      }}
      autoFocus={true}
      centered={true}
    >
      {successDlg ? (
        <SweetAlert
          success
          title={"Criado"}
          onConfirm={() => {
            props.getAllMenus();
            setSuccessDlg(false);
            toggle();
          }}
        >
          {"Botão criado com sucesso!"}
        </SweetAlert>
      ) : null}
      {submitErrorMessage && (
        <SweetAlert
          danger
          title={"Erro"}
          onConfirm={() => setSubmitErrorMessage("")}
        >
          {submitErrorMessage}
        </SweetAlert>
      )}
      <ModalHeader toggle={toggle}>Novo Botão</ModalHeader>
      <ModalBody>
        <form onSubmit={submitForm}>
          <Row>
            <Col lg={12}>
              <div>
                <label className="form-label">Nome*</label>
                <input
                  className="form-control"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {nameErro && <span className="text-danger">{nameErro}</span>}
              </div>
            </Col>
          </Row>

          <Row style={{ paddingTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">URL*</label>
                <input
                  className="form-control"
                  type="text"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                />
                <div>
                  <span
                    style={{
                      fontWeight: "bold",
                      marginRight: "4px",
                    }}
                  >
                    Importante:
                  </span>
                  Caso a URL não tenha um parâmetro com ?, insira o parâmetro
                  ?enabled=true ao final da URL.
                </div>
                {urlErro && <span className="text-danger">{urlErro}</span>}
              </div>
            </Col>
          </Row>

          <Row style={{ paddingTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Nome de Exibição*</label>
                <input
                  className="form-control"
                  type="text"
                  value={nameExhibition}
                  onChange={(e) => setNameExhibition(e.target.value)}
                />
                {nameExErro && (
                  <span className="text-danger">{nameExErro}</span>
                )}
              </div>
            </Col>
          </Row>

          <Row style={{ paddingTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Ícone*</label>
                <input
                  className="form-control"
                  type="file"
                  id="formFile"
                  onChange={(e) =>
                    setIcon(
                      e.target.files.length > 0
                        ? { files: e.target.files }
                        : null,
                    )
                  }
                />
                {imageErro && <span className="text-danger">{imageErro}</span>}
              </div>
            </Col>
          </Row>

          <Row style={{ paddingTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Grupos</label>
                <Select
                  value={groupsMulti}
                  placeholder={"Selecione"}
                  isMulti={true}
                  onChange={(e) => {
                    handleGroupMulti(e);
                  }}
                  noOptionsMessage={() => "Nenhuma opção encontrada"}
                  options={[
                    {
                      options:
                        groups?.length > 0 && !allGroups
                          ? [
                              { label: "TODOS", value: "todos" },
                              ...groups.map((e) => {
                                return { label: e.name, value: e.id };
                              }),
                            ]
                          : [],
                    },
                  ]}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
          </Row>

          <Row className="gy-4" style={{ marginTop: 20, marginBottom: 20 }}>
            <Col md={6}>
              <div className="form-check form-check-end">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkVisible"
                  checked={isVisible}
                  onChange={(e) => setIsVisible(e.target.checked)}
                />
                <label htmlFor="checkVisible">Visível</label>
              </div>
            </Col>

            <Col md={6}>
              <div className="form-check form-check-end">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkExternal"
                  checked={isEmbeded}
                  onChange={(e) => setIsEmbeded(e.target.checked)}
                />
                <label htmlFor="checkExternal">Externo</label>
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: 20 }}>
            <Col md={6}>
              <div className="form-check form-check-end">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkText"
                  onChange={(e) => setSeparateText(e.target.checked)}
                />
                <label htmlFor="checkText">
                  Separar Texto da Imagem (Menu)
                </label>
              </div>
            </Col>

            {separateText && (
              <Col md={6}>
                <ColorPicker
                  classOfContainer="primary-card-pickr"
                  setStateFunc={setColorText}
                  defaultColor={colorText}
                  labelText="Cor do texto *"
                  idDiv="corTexto"
                  noMargin={true}
                />
              </Col>
            )}
          </Row>

          {!hideHeader && (
            <Row style={{ marginTop: 20 }}>
              <Col md={6}>
                <div className="form-check form-check-end">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="checkHeaderColor"
                    checked={headerColorEnabled}
                    onChange={(e) => setHeaderColorEnabled(e.target.checked)}
                  />
                  <label htmlFor="checkHeaderColor">
                    Alterar Cor do Topo e Ícones
                  </label>
                </div>
              </Col>

              {headerColorEnabled && (
                <Col md={6}>
                  <ColorPicker
                    classOfContainer="menu-header-color-pickr"
                    setStateFunc={setHeaderColor}
                    defaultColor={headerColor}
                    labelText="Cor do topo *"
                    idDiv="corTopo"
                    noMargin={true}
                  />
                </Col>
              )}
            </Row>
          )}

          <Row style={{ marginTop: 20 }}>
            <Col md={12}>
              <div className="form-check form-check-end">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="checkHideHeader"
                  checked={hideHeader}
                  onChange={(e) => setHideHeader(e.target.checked)}
                />
                <label htmlFor="checkHideHeader">Remover Topo</label>
              </div>

              {hideHeader && (
                <div>
                  <span style={{ fontWeight: "bold" }}>Importante:</span>{" "}
                  <span>
                    Para não utilizar o voltar do aplicativo utilize o parâmetro
                    back_button=false e insira a função <ModalGoBackFunction />{" "}
                    na tela a ser embedada.
                  </span>
                </div>
              )}
            </Col>
          </Row>

          <Row
            style={{
              width: "100%",
              margin: "auto",
              display: "flex",
              justifyContent: "flex-end",
              paddingTop: 10,
            }}
          >
            <Button
              color="success"
              className="btn btn-danger waves-effect waves-light"
              style={{ width: 80, marginRight: 5 }}
              onClick={() => toggle()}
            >
              Fechar
            </Button>
            <ButtonSpinner isLoading={isLoading} title={"Salvar"} />
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(NewMenu);
